import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routesName } from '../constants/routes-name';

function Component() {
  const { user } = useSelector(({ user }) => user);
  if (user?.email) {
    return <Navigate to={routesName.dashboard} />;
  }

  return <Layout />;
}

function Layout() {
  return <Outlet />;
}

export default Component;
